import React, { createContext, useState, useContext } from 'react';

// Données mockées
const mockPrescriptions = [
  { 
    id: '1', 
    patientId: 'CNAMGS-123456', 
    doctorId: 'D001', 
    doctorName: 'Dr. Nzogho', 
    date: '2025-03-12', 
    medicines: [
      { id: 'M1', name: 'Paracétamol', dosage: '500mg', quantity: 10, instruction: '2 comprimés par jour' }
    ], 
    status: 'pending' 
  },
  { 
    id: '2', 
    patientId: 'CNAMGS-123456', 
    doctorId: 'D002', 
    doctorName: 'Dr. Mba', 
    date: '2025-03-01', 
    medicines: [
      { id: 'M2', name: 'Amoxicilline', dosage: '250mg', quantity: 15, instruction: '3 fois par jour' }
    ], 
    status: 'dispensed' 
  },
  { 
    id: '3', 
    patientId: 'CNAMGS-789012', 
    doctorId: 'D001', 
    doctorName: 'Dr. Nzogho', 
    date: '2025-03-10', 
    medicines: [
      { id: 'M3', name: 'Ibuprofène', dosage: '400mg', quantity: 20, instruction: '1 comprimé après les repas' }
    ], 
    status: 'pending' 
  }
];

const mockReimbursements = [
  { 
    id: 'R1', 
    prescriptionId: '1', 
    patientId: 'CNAMGS-123456', 
    pharmacyId: 'PH001', 
    amount: 15000, 
    date: '2025-03-12', 
    status: 'pending' 
  },
  { 
    id: 'R2', 
    prescriptionId: '2', 
    patientId: 'CNAMGS-123456', 
    pharmacyId: 'PH002', 
    amount: 2500, 
    date: '2025-03-01', 
    status: 'approved' 
  },
  { 
    id: 'R3', 
    prescriptionId: '3', 
    patientId: 'CNAMGS-789012', 
    pharmacyId: 'PH001', 
    amount: 8000, 
    date: '2025-03-10', 
    status: 'pending' 
  }
];

const mockFraudAlerts = [
  { 
    id: 'F1', 
    type: 'Prescription suspecte', 
    description: 'Plusieurs prescriptions identiques en peu de temps', 
    severity: 'medium', 
    date: '2025-03-15', 
    status: 'new' 
  }
];

const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [prescriptions, setPrescriptions] = useState(mockPrescriptions);
  const [reimbursements, setReimbursements] = useState(mockReimbursements);
  const [fraudAlerts, setFraudAlerts] = useState(mockFraudAlerts);

  const addPrescription = (prescription) => {
    setPrescriptions([...prescriptions, prescription]);
  };

  const updatePrescriptionStatus = (id, status) => {
    setPrescriptions(prescriptions.map(p => p.id === id ? { ...p, status } : p));
  };

  const updateReimbursementStatus = (id, status) => {
    setReimbursements(reimbursements.map(r => r.id === id ? { ...r, status } : r));
  };

  const addFraudAlert = (alert) => {
    setFraudAlerts([...fraudAlerts, alert]);
  };

  return (
    <DataContext.Provider value={{
      prescriptions,
      reimbursements,
      fraudAlerts,
      addPrescription,
      updatePrescriptionStatus,
      updateReimbursementStatus,
      addFraudAlert
    }}>
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error('useData must be used within DataProvider');
  }
  return context;
};